module.exports = "/_next/static/images/WebSecondIntroduce-fe1b8e4057fda1b241aaff8149c2ca03.png";